import { createAppI18n } from '../../../shared/setup-i18n'

const i18n = createAppI18n('commonHeader')

export function getLogoMainText(ctx = {}) {
  const { t } = i18n.global
  const { isLoggedInMA, isExternalUserView, logoText = '', isAdminMenu, sideMenuConfig = {} } = ctx
  if (isLoggedInMA) {
    ctx.logoTextId = 'sub-account'
    return t('logo.subAccount')
  }
  if (isExternalUserView) {
    ctx.logoTextId = 'external-account'
    return t('logo.externalAccount')
  }
  if (logoText) {
    return logoText
  }
  if (isAdminMenu || sideMenuConfig?.isVideoSdk) {
    ctx.logoTextId = 'admin-center'
    return t('logo.adminCenter')
  }
  return ''
}

export function shouldShowHeaderSlots() {
  const { logoTextId } = window.microsDatas || {}
  return ['home', 'my-account', 'meetings', 'admin-center'].includes(logoTextId)
}

export function shouldShowAicPanel(ctx = {}) {
  const { cluster = '' } = window.microsDatas || {}
  const normalizedCluster = String(cluster).toLowerCase()
  const isAllowedCluster = normalizedCluster === 'dev' || normalizedCluster === 'dg01'
  return Boolean(isAllowedCluster || (ctx.enableAicPanel && ctx.isHaveSideMenu && ctx.isAdminMenu))
}

export function isBasePortal({ ctx = {} }) {
  return (
    ctx.logoTextId === 'my-account' ||
    ctx.logoTextId === 'home' ||
    ctx.isAdminMenu ||
    ctx.sideMenuConfig?.isVideoSdk ||
    ctx.useSimplifiedHeaderRaw
  )
}

export function getWaffleMenuConfig(ctx = {}) {
  const hideWaffle = ctx.sideMenuConfig?.isVideoSdk
  return hideWaffle ? false : { meetingShortcut: { target: '_blank' } }
}
